module.exports = __webpack_public_path__ + "4caa33c93150adb7bf953d97d85c620d.jpg";